// extracted by mini-css-extract-plugin
export default {"spin-container":"styles_spin-container__kcdGH","spin":"styles_spin__-Ixwh"};